import { render, staticRenderFns } from "./prescription-select.vue?vue&type=template&id=6493cb8c&scoped=true&"
import script from "./prescription-select.vue?vue&type=script&lang=ts&"
export * from "./prescription-select.vue?vue&type=script&lang=ts&"
import style0 from "./prescription-select.vue?vue&type=style&index=0&id=6493cb8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6493cb8c",
  null
  
)

export default component.exports